import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "display",
    "quantityInput",
    "decrementBtn",
    "incrementBtn",
    "priceQty",
    "priceTotal",
    "priceUnit",
    "addOnKeyInput",
    "tierCard",
    "packHint",
  ];
  static values = {
    unitPrice: Number,
    unitSize: Number,
    maxQuantity: { type: Number, default: 10 },
    tiers: { type: Array, default: [] },
  };

  connect() {
    this._hasQuantityUI =
      this.hasQuantityInputTarget && this.hasDisplayTarget;
    if (!this._hasQuantityUI) return;

    this.quantity = parseInt(this.quantityInputTarget.value, 10) || 1;
    this._render();
  }

  increment() {
    if (!this._hasQuantityUI) return;
    if (this.quantity < this.maxQuantityValue) {
      this.quantity++;
      this._render();
    }
  }

  decrement() {
    if (!this._hasQuantityUI) return;
    if (this.quantity > 1) {
      this.quantity--;
      this._render();
    }
  }

  selectTier(event) {
    if (!this._hasQuantityUI) return;
    const key = event.currentTarget.dataset.tierKey;
    const tier = this.tiersValue.find((t) => t.key === key);
    if (!tier) return;

    this.unitPriceValue = tier.unit_price;
    this.unitSizeValue = tier.unit_size;
    this.maxQuantityValue = tier.max_addable;

    if (this.hasAddOnKeyInputTarget) {
      this.addOnKeyInputTarget.value = key;
    }

    this.tierCardTargets.forEach((card) => {
      const isSelected = card.dataset.tierKey === key;
      card.classList.toggle("ring-2", isSelected);
      card.classList.toggle("ring-indigo-500", isSelected);
      card.classList.toggle("border-indigo-500", isSelected);
      card.classList.toggle("border-gray-200", !isSelected);
    });

    if (this.quantity > this.maxQuantityValue) {
      this.quantity = Math.max(this.maxQuantityValue, 1);
    }

    this._render();
  }

  _render() {
    if (!this._hasQuantityUI) return;
    this.displayTarget.textContent = this.quantity;
    this.quantityInputTarget.value = this.quantity;
    this.decrementBtnTarget.disabled = this.quantity <= 1;
    this.incrementBtnTarget.disabled =
      this.quantity >= this.maxQuantityValue || this.maxQuantityValue === 0;

    if (this.hasPriceQtyTarget) {
      this.priceQtyTarget.textContent = `× ${this.quantity}`;
    }
    if (this.hasPriceUnitTarget && this.hasUnitPriceValue) {
      const unit = this.unitPriceValue / 100;
      this.priceUnitTarget.textContent = `$${unit.toFixed(2)}/mo`;
    }
    if (this.hasPriceTotalTarget && this.hasUnitPriceValue) {
      const total = (this.unitPriceValue * this.quantity) / 100;
      this.priceTotalTarget.textContent = `$${total.toFixed(2)}`;
    }
    if (this.hasPackHintTarget && this.hasUnitSizeValue) {
      const size = this.unitSizeValue.toLocaleString();
      this.packHintTarget.textContent = `Each pack adds ${size} units. You can add up to ${this.maxQuantityValue} more.`;
    }
  }
}
